<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview>
                    <template v-slot:body>
                        <div class="d-flex row justify-content-between align-items-center border-bottom mb-4">
                            <div>
                                <p class="font-weight-bold">
                                    Tahun Akadmik:
                                    <span class="font-weight-normal">{{ datatahun }}</span>
                                </p>
                            </div>
                            <div>
                                <p class="font-weight-bold">
                                    Semester:
                                    <span class="font-weight-normal">Semester {{ dataSemester }}</span>
                                </p>
                            </div>
                        </div>
                        <div>
                            <div v-if="selected === false && data.length === 0">
                                <div class="row justify-content-center align-items-center text-center">
                                    <div class="col-12">
                                    <img src="/media/siak/xadfs-01-01.png" width="500" height="500" class="icon mx-auto mb-6" />
                                    <h1 class="mb-6">
                                        Rekapitulasi Pengisian Survey Taruna Belum Tersedia
                                    </h1>
                                    </div>
                                </div>
                            </div>
                            <b-button v-if="selected == false && isDataExist == true" variant="primary" @click="onSelect(true, 'answer')" class="px-8 py-6 w-100 rounded-lg shadow-sm">
                                <div class="d-flex row justify-content-between align-items-center text-white m-0">
                                    <span> Isi Kuisoner Keperluan Taruna </span>
                                    <b-icon icon="chevron-right"></b-icon>
                                </div>
                            </b-button>
                            <b-button v-else-if="selected == false && isDataExist == false && data.length > 0" @click="onSelect(true, 'feedback')" class="px-8 py-6 w-100 rounded-lg bg-white shadow-sm mt-4"
                                style="border-top: 12px; border-bottom: 12px; border-right-width: 8px; border-left-width: 8px; border-color: orange;">
                                <div class="d-flex row justify-content-between align-items-center text-black m-0">
                                    <span> Isi Kuisoner Keperluan Taruna </span>
                                    <b-icon icon="chevron-right"></b-icon>
                                </div>
                            </b-button>
                        </div>

                        <div v-if="selected == true && type == 'answer'">
                            <div class="mb-10 w-100">
                                <h2 class="text-center mb-10" style="font-weight: bold; text-transform: uppercase;">
                                    Lembar Kuisoner Tingkat Kepuasan Taruna AD
                                </h2>
                                <p style="margin-bottom: 4px; font-weight: 400; font-size: 16px;">
                                    Petunjuk Penilaian Taruna Terhadap Sarana Dan Prasarana
                                </p>
                                <p style="margin-bottom: 4px;font-weight: 400;font-size: 16px;">
                                    Berikanlah penilian yang jujur, Objektif dan
                                    penuh tanggung jawab terhadap sarana dan
                                    prasarana yang ad di AD secara keseluruha,
                                    Aspek-aspek yang dinilai tercantum dalam
                                    form dibawah
                                </p>
                            </div>

                            <b-form>
                                <div class="mb-4">
                                    <template>
                                        <div v-for="(question, key) in data" :key="key">
                                            <p style="color: #485377;font-size: medium;font-weight: 500;">
                                                <input type="hidden" id="question1" v-model="question.pertanyaan" />
                                                {{ key + 1 }}.
                                                {{ question.pertanyaan }}
                                                <br />
                                                <template>
                                                    <label class="ml-8 my-4 mr-4" v-for="(nilai, keys) in nilai" :key="keys">
                                                        <input type="radio" class="cheker" :checked="dataAnswer[key].id_bobot ==nilai.key" disabled />
                                                        {{ nilai.predikat }}
                                                    </label>
                                                </template>
                                            </p>
                                        </div>
                                    </template>
                                </div>
                            </b-form>

                            <div class="row align-items-center justify-content-end" style="margin-top: 5%">
                                <b-button v-if="selected == true" @click="onBack()" variant="primary" class="rounded">
                                    Kembali
                                </b-button>
                            </div>
                        </div>
                        <div v-if="selected == true && type == 'feedback'">
                            <div class="mb-10 w-100">
                                <h2 class="text-center mb-10" style="font-weight: bold; text-transform: uppercase;">
                                    Lembar Kuisoner Tingkat Kepuasan Taruna AD
                                </h2>
                                <p style="margin-bottom: 4px;font-weight: 400;font-size: 16px;">
                                    Petunjuk Penilaian Taruna Terhadap Sarana
                                    Dan Prasarana
                                </p>
                                <p style="margin-bottom: 4px;font-weight: 400;font-size: 16px;">
                                    Berikanlah penilian yang jujur, Objektif dan
                                    penuh tanggung jawab terhadap sarana dan
                                    prasarana yang ad di AD secara keseluruha,
                                    Aspek-aspek yang dinilai tercantum dalam
                                    form dibawah
                                </p>
                            </div>

                            <b-form @submit.prevent="onSubmit">
                                <div class="mb-4">
                                    <template>
                                        <div v-for="(question, key) in data" :key="key">
                                            <p style="color: #485377;font-size: medium;font-weight: 500;">
                                                <input type="hidden" id="question1" v-model="question.pertanyaan" />
                                                {{ key + 1 }}.
                                                {{ question.pertanyaan }}
                                                <br />
                                                <template>
                                                    <label class="ml-8 my-4 mr-4" v-for="(nilai, keys) in nilai" :key="keys">
                                                        <input :value="nilai.key" v-model="data[key].status" type="radio" class="cheker" autocomplete="off" />
                                                        {{ nilai.predikat }}
                                                    </label>
                                                </template>
                                            </p>
                                        </div>
                                    </template>
                                </div>

                                <div class="row align-items-center justify-content-end" style="margin-top: 5%">
                                    <div class="col-lg-6" style="display: flex">
                                        <b-button type="submit" variant="outline-primary" style="margin-left: auto">Simpan</b-button>
                                        <b-button type="reset" @click="onBack()" variant="outline-danger" class="ml-2" style="margin-left: auto">Batal</b-button>
                                    </div>
                                </div>
                                </b-form>
                        </div>
                    </template>
                </KTCodePreview>
            </div>
        </div>
    </div>
</template>

<script>
import KTCodePreview from '@/view/content/CardContent.vue';
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
import axios from 'axios';

export default {
    data() {
        return {
            selected: false,
            type: '',
            isDataExist: false,
            data: [],
            dataAnswer: [],
            nilai: [],
            id_pertanyaan: [],
            id_bobot: [],
            status_isi: true,
            datatahun: null,
            dataSemester: null,
        };
    },
    components: {
        KTCodePreview,
    },

    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Evaluasi Taruna' }]);

        this.getData();
        // this.getDataTA();
    },
    methods: {
        refreshData(result, alert) {
            if (result.data.meta.code == 200) {
                this.selected = false;
                this.$swal(`Success ${alert} Data`);
                this.getData();
            } else {
                this.$swal(`Failed`);
            }
        },
        async getDataTA() {
            const dataLogin = JSON.parse(localStorage.getItem('dataLogin'));
            this.dataSemester = dataLogin.semester;
            const dataAkademik = await axios.get('/master/generations')
            const fil = dataAkademik.data.data.find(item => item.key === dataLogin.key_generation);
            if (fil) {
                this.datatahun = fil.tahun + ' - ' + fil.tahun_akhir + ' / ' + fil.semester;
                // this.request.generation_id = fil.key;
                // this.getDataDosen(fil.key);
            }
            let result = await axios.get(
                '/master/generations/ta-aktif'
            );
            this.key_ta = result.data.data.key
            this.tahun_akademik = result.data.data
            let result_jadwal = await axios.get(
                `/penilaian-dosen/jadwal-evaluasi/filter-by-ta/${this.key_ta}`
            );
            if(result_jadwal.data.data.id_angkatan==null){
                this.cek_jadwal = false
            } else {
                this.cek_jadwal = true
            }
            const result_smt = await axios.get(`dashboard/detail-siswa`);
            this.semester = result_smt.data.data.semester
        },
        async getDataQuestion() {
            let question = await axios.get(
                '/survey-kepuasan/taruna/pertanyaan/index'
            );

            const dataQuestion = question.data.data.pertanyaan;
            this.datatahun = question.data.data.ta;
            this.dataSemester = question.data.data.semester

            this.data = dataQuestion;
        },
        async getNilai() {
            try {
                let result = await axios.get(
                    'survey-kepuasan/bobot-penilaian/index'
                );

                this.nilai = result.data.data;
            } catch (error) {
                throw error;
            }
        },
        async getData() {
            // const dataLogin = JSON.parse(localStorage.getItem('dataLogin'));
            // this.dataSemester = dataLogin.semester;
            // const dataAkademik = await axios.get('/master/generations')
            // const fil = dataAkademik.data.data.find(item => item.key === dataLogin.key_generation);
            // if (fil) {
            //     this.datatahun = fil.tahun + ' - ' + fil.tahun_akhir + ' / ' + fil.semester;
            //     // this.request.generation_id = fil.key;
            //     // this.getDataDosen(fil.key);
            // }
            await axios
                .get('survey-kepuasan/taruna/angket/check-answer')
                .then((res) => {
                    const dataAnswer = res.data.data;
                    if (res.data.meta.code == 200) {
                        if (dataAnswer.length != 0) {
                            this.isDataExist = true;
                            this.dataAnswer = dataAnswer;
    
                            this.getDataQuestion();
                            this.getNilai();
                        } else {
                            this.isDataExist = false;
                            this.getDataQuestion();
                            this.getNilai();
                        }
                    }
                })
                .catch((error) => {
                    this.$swal('Failed');
                    throw error;
                });
        },
        onSelect(selected, type) {
            this.selected = selected;
            this.type = type;
        },
        onBack() {
            this.selected = false;
        },
        onSubmit() {
            this.status_isi = true;

            for (let i = 0; i < this.data.length; i++) {
                if (
                    this.data[i].status == true ||
                    this.data[i].status == false
                ) {
                    this.status_isi = true;
                }
            }

            if (this.status_isi == true) {
                this.selectedAnswer = this.data;

                for (let i = 0; i < this.selectedAnswer.length; i++) {
                    this.id_pertanyaan.push(this.selectedAnswer[i].key);
                    this.id_bobot.push(this.selectedAnswer[i].status);
                }

                try {
                    var formData = {
                        id_pertanyaan: this.id_pertanyaan,
                        id_bobot: this.id_bobot,
                    };

                    this.$swal({
                        title: 'Are you sure?',
                        text: 'Make Sure Your Answer is Correct !',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, submit now!',
                        cancelButtonText: 'No, cancel!',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                    }).then(async (result) => {
                        if (result.value) {
                            axios
                                .post(
                                    '/survey-kepuasan/taruna/angket/save',
                                    formData
                                )
                                .then((res) => {
                                    this.selected = false;

                                    if (res.data.meta.code === 0) {
                                        this.$swal(res.data.meta.message);
                                        return;
                                    }

                                    this.refreshData(res, 'Answer Saved');
                                })
                                .catch((error) => {
                                    this.$swal('Failed Submit Data Angket');

                                    throw error;
                                });
                        }
                    });
                } catch (error) {
                    throw error;
                }
            }
        },
    },
};
</script>
